import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./styles/variable.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./components/state/store";
import { RouterProvider } from "react-router-dom";
import router from "./routes/routerConfig";
import { setFeatureFlag } from "./components/state/action/globalAction";

// Read feature flag from query string once at startup
try {
  const params = new URLSearchParams(window.location.search);
  const flag = params.get("metrics");
  const locale = params.get("locale") || "en";
  const effectiveFlag = locale === "ja" ? false : flag;
  if (effectiveFlag !== null) {
    store.dispatch(setFeatureFlag(effectiveFlag));
  }
} catch (e) {
  console.log(e);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
